// /js/tiptap/ChartImagesSection.js
import { Node } from '@tiptap/core'

export const ChartImagesSection = Node.create({
  name: 'chart_images_section',

  group: 'block',
  content: 'chart_image*',

  isolating: true,
  defining: true,
  selectable: false,

  parseHTML() {
    return [{ tag: 'chart-images-section' }]
  },

  renderHTML() {
    return ['chart-images-section', {}, 0]
  },

  addNodeView() {
    return () => {
      const dom = document.createElement('chart-images-section')
      dom.className = 'chart_images_section'
      dom.tabIndex = -1

      // Header (non-editable)
      const header = document.createElement('div')
      header.className = 'chart_images_header'
      header.textContent = 'Images'

      // Prevent header from interfering with editor focus
      header.addEventListener('mousedown', e => {
        e.preventDefault()
      })

      // Content container (chart_image nodes render here)
      const content = document.createElement('div')
      content.className = 'chart_images_content'

      dom.appendChild(header)
      dom.appendChild(content)

      return {
        dom,
        contentDOM: content,
      }
    }
  },
})
